import { AxiosResponse } from 'axios';
import { MataPelajaran } from '../../entities/MataPelajaran';

export class MataPelajaranDataMapper {
  public convertMataPelajaranDataFromApi(
    result: AxiosResponse<any>
  ): MataPelajaran[] {
    const { data } = result.data;

    let mataPelajaran: MataPelajaran[] = [];

    data.map((mp: any) => {
      return mataPelajaran.push(
        new MataPelajaran(
          mp.id,
          mp.jenjang,
          mp.mata_pelajaran,
          mp.created_at,
          mp.updated_at
        )
      );
    });

    return mataPelajaran;
  }
}
